export const accordionSpeed = 100;
export const accordionEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';
export const pageLoaderEasingFn = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

export const breadcrumbsSpeed = 100;
export const breadcrumbsDelay = 50;
export const breadcrumbsEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';

export const tooltipSpeed = 200;
export const tooltipDuration = 2000;
export const tooltipDelay = 50;
export const tooltipEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';

export const snackbarSpeed = 200;
export const snackbarEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/transitions-props.js